<div id="reqNotesTabContent">
  <label [hidden]="hidePreviousNotes()">Previous Notes</label>
  <textarea
    id="old_notes"
    disabled="disabled"
    style="height: 10em"
    class="form-control w-100 mb-5 k-textbox"
    [value]="previousNotes() ?? ''"
    [hidden]="hidePreviousNotes()"
  ></textarea>
  @if (!hideNewNote()) {
    <label>Add Note</label>
    <textarea
      id="new_note"
      style="height: 6em"
      class="form-control w-100 k-textbox"
      [formField]="noteForm"
      (change)="onNewNoteChange()"
    ></textarea>
  }
</div>
